/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomMessageAdminDto } from '../models/CustomMessageAdminDto';
import type { GetCustomMessageClientResponse } from '../models/GetCustomMessageClientResponse';
import type { GetCustomMessageDistrictsResponseAdmin } from '../models/GetCustomMessageDistrictsResponseAdmin';
import type { GetCustomMessageRegionsResponseAdmin } from '../models/GetCustomMessageRegionsResponseAdmin';
import type { GetCustomMessageUsersResponseAdmin } from '../models/GetCustomMessageUsersResponseAdmin';
import type { Language } from '../models/Language';
import type { Pagination1OfCustomMessagesListedAdminDto } from '../models/Pagination1OfCustomMessagesListedAdminDto';
import type { PostCustomMessageRequestAdmin } from '../models/PostCustomMessageRequestAdmin';
import type { PutCustomMessageDistrictsRequestAdmin } from '../models/PutCustomMessageDistrictsRequestAdmin';
import type { PutCustomMessageRegionsRequestAdmin } from '../models/PutCustomMessageRegionsRequestAdmin';
import type { PutCustomMessageRequestAdmin } from '../models/PutCustomMessageRequestAdmin';
import type { PutCustomMessageUsersRequestAdmin } from '../models/PutCustomMessageUsersRequestAdmin';
import type { UserAppType } from '../models/UserAppType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomMessagesService {
    /**
     * @returns GetCustomMessageClientResponse OK
     * @throws ApiError
     */
    public static getClientCustomMessagesClient({
        userAppType,
        userAddressId,
        cachedMessages,
    }: {
        userAppType: UserAppType,
        userAddressId: number,
        cachedMessages?: Array<string>,
    }): CancelablePromise<GetCustomMessageClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/custommessages',
            query: {
                'cachedMessages': cachedMessages,
                'userAppType': userAppType,
                'userAddressId': userAddressId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetCustomMessageClientResponse OK
     * @throws ApiError
     */
    public static getPublicClientCustomMessagesClient({
        userAppType,
        regionId,
        cachedMessages,
        language,
        locationLongitude,
        locationLatitude,
    }: {
        userAppType: UserAppType,
        regionId: number,
        cachedMessages?: Array<string>,
        language?: Language,
        locationLongitude?: number,
        locationLatitude?: number,
    }): CancelablePromise<GetCustomMessageClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/custommessages/public',
            query: {
                'cachedMessages': cachedMessages,
                'language': language,
                'userAppType': userAppType,
                'regionId': regionId,
                'location.longitude': locationLongitude,
                'location.latitude': locationLatitude,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCustomMessageDetails`
     * @returns CustomMessageAdminDto OK
     * @throws ApiError
     */
    public static getCustomMessageAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<CustomMessageAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/custommessages/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCustomMessage`
     * @returns void
     * @throws ApiError
     */
    public static updateCustomMessageAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCustomMessageRequestAdmin,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/custommessages/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteCustomMessage`
     * @returns void
     * @throws ApiError
     */
    public static deleteCustomMessageAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/custommessages/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCustomMessages`
     * @returns Pagination1OfCustomMessagesListedAdminDto OK
     * @throws ApiError
     */
    public static listAdminCustomMessagesAdmin({
        title,
        regionId,
        districtId,
        userIds,
        language,
        mobileAppType,
        startAt,
        endAt,
        page,
        limit,
    }: {
        title?: string,
        regionId?: number,
        districtId?: number,
        userIds?: Array<string>,
        language?: Language,
        mobileAppType?: UserAppType,
        startAt?: string,
        endAt?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfCustomMessagesListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/custommessages',
            query: {
                'title': title,
                'regionId': regionId,
                'districtId': districtId,
                'userIds': userIds,
                'language': language,
                'mobileAppType': mobileAppType,
                'startAt': startAt,
                'endAt': endAt,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCustomMessage`
     * @returns void
     * @throws ApiError
     */
    public static createCustomMessageAdmin({
        requestBody,
    }: {
        requestBody?: PostCustomMessageRequestAdmin,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/custommessages',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCustomMessageDetails`
     * @returns GetCustomMessageRegionsResponseAdmin OK
     * @throws ApiError
     */
    public static customMessageRegionsAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetCustomMessageRegionsResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/custommessages/{id}/regions',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCustomMessage`
     * @returns void
     * @throws ApiError
     */
    public static putCustomMessageRegionsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCustomMessageRegionsRequestAdmin,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/custommessages/{id}/regions',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCustomMessageDetails`
     * @returns GetCustomMessageDistrictsResponseAdmin OK
     * @throws ApiError
     */
    public static customMessageDistrictsAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetCustomMessageDistrictsResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/custommessages/{id}/districts',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCustomMessage`
     * @returns void
     * @throws ApiError
     */
    public static putCustomMessageDistrictsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCustomMessageDistrictsRequestAdmin,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/custommessages/{id}/districts',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCustomMessageDetails`
     * @returns GetCustomMessageUsersResponseAdmin OK
     * @throws ApiError
     */
    public static customMessageUsersAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetCustomMessageUsersResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/custommessages/{id}/users',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCustomMessage`
     * @returns void
     * @throws ApiError
     */
    public static putCustomMessageUsersAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCustomMessageUsersRequestAdmin,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/custommessages/{id}/users',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
